import type { PickByValue } from "utility-types";

export function binds<T extends object>(obj: T) {
  const _bind: Record<keyof any, (...args: any[]) => any> = {};
  return new Proxy<PickByValue<T, ((...args: any[]) => any) | undefined>>(obj, {
    get: (target, prop) => {
      if (_bind[prop]) {
        return _bind[prop];
      }

      const fn = target[prop as keyof typeof target] as (...args: any[]) => any;
      if (!fn) {
        return fn;
      }
      const bindFn = fn.bind(target);

      _bind[prop] = bindFn;

      return bindFn;
    },
  });
}
